<script lang="ts">
  import type { SelectType } from '$src/types/forms';

  let {
    id,
    name,
    background,
    value = $bindable(''),
    options = [],
    attributes,
    required,
    showFirstEmptyValue,
    onBlur,
    onFocus,
    onChange,
  }: SelectType = $props();
</script>

<select
  {id}
  {name}
  {required}
  bind:value
  onfocus={onFocus}
  onblur={onBlur}
  onchange={onChange}
  {...attributes}
  class={`
    2xl:fluid-text-[16] 2xl:fluid-h-[48] h-12 w-full border-b-1 focus:outline-offset-3
    ${background === 'black' ? 'border-white-1000 text-white-1000 like-select-bg-black' : 'border-black-1000 placeholder:text-black-600 text-black-1000 like-select-bg-yellow'}
  `}
>
  {#if showFirstEmptyValue}
    <option value="">Maak je keuze</option>
  {/if}
  {#if options.length > 0}
    {#each options as option (option.value)}
      <option value={option.value}>{option.label}</option>
    {/each}
  {/if}
</select>
